import React, { useEffect, useState, useMemo } from "react";
import PropTypes from "prop-types";
import { useParams, withRouter } from "react-router-dom";
import {
  CardBody,
  Container,
  Row,
  Card,
  Spinner,
  Alert,
  Col,
} from "reactstrap";

//Import Breadcrumb
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import CommentaireSlider from "../../../Components/Common/CommentaireSlider";
import TableContainer from "../../../Components/Common/TableContainer";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withTranslation } from "react-i18next";
import axiosInstance from "../../../axiosConfig";

//redux
import {
  getCommentLivreur,
  getRevenuebyLivreur,
  getLivreurCourses,
  getLivreurCoursesIn,
  getParainageInfoClient,
} from "../../../common/data";

import InfosPersonnelle from "../../../Components/Common/InfosPersonnelle";
import StatistiquesDetail from "../../../Components/Common/StatistiquesDetail";
import NoteCommentaire from "../../../Components/Common/NoteCommentaire";
import DocumentsPersonnelle from "../../../Components/Common/DocumentsPersonnelle";
import Loader from "../../../Components/Common/Loader";

const LivreurActivityHistory = (props) => {
  function formatDate(date) {
    const dateObject = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    });
    return dateObject;
  }

  const AgentId = useParams("id");

  const [reload, setReload] = useState(true);
  const [loading, setLoading] = useState(true);
  const [selectlivreur, setSelectLivreur] = useState({});
  const [commentaires, setCommentaires] = useState([]);
  const [livreurCourses, setLivreurCourses] = useState([]);
  const [livreurCoursesIn, setLivreurCoursesIn] = useState([]);
  const [livreurCoursesRevenue, setLivreurCoursesRevenue] = useState(0);
  const [livreurParainage, setLivreurParainage] = useState({});

  const fetchDriverData = async () => {
    setLoading(true);
    try {
      const driverDetail = await axiosInstance.get(
        `/driverdetail/?id=${AgentId.id}/`
      );
      setSelectLivreur(driverDetail.data.data);
      if (driverDetail?.data) {
        const divrerData = driverDetail.data.data;
        // console.log("divrerData: ", divrerData);

        const coursesLivreur = await getLivreurCourses(divrerData.user_id);
        setLivreurCourses(coursesLivreur);

        const coursesLivreurIn = await getLivreurCoursesIn(divrerData.user_id);
        setLivreurCoursesIn(coursesLivreurIn);
        // console.log("coursesLivreurIn: ", coursesLivreurIn);

        const revenuCoursesLivreur = await getRevenuebyLivreur(
          divrerData.user_id
        );
        setLivreurCoursesRevenue(revenuCoursesLivreur);
        // console.log("revenuCoursesLivreur: ", revenuCoursesLivreur);

        const commentaireLivreur = await getCommentLivreur(divrerData.user_id);
        setCommentaires(commentaireLivreur);
        // console.log("commentaireLivreur: ", commentaireLivreur);

        const parraingeInfo = await getParainageInfoClient(divrerData.user_id);
        setLivreurParainage({
          parainee: parraingeInfo?.filleuls || 0,
          revenus: parraingeInfo?.gains || 0,
        });
      }
    } catch (err) {
      console.error("Echec de récupération des données: ", err);
      toast.error("Échec de récupération des données.");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchDriverData();
    setReload(true);
  }, [reload]);

  const columnsTable = useMemo(
    () => [
      {
        Header: "Nom",
        accessor: "last_name",
        filterable: false,
        Cell: (cell) => {
          return cell.row.original.last_name;
        },
      },
      {
        Header: "Prénom",
        accessor: "first_name",
        filterable: false,
        Cell: (cellProps) => {
          return cellProps.row.original.first_name;
        },
      },
      {
        Header: "Statut livraison",
        accessor: "statut",
        filterable: true,
      },
      {
        Header: "Date",
        accessor: "date",
        filterable: false,
        Cell: (cellProps) => {
          return formatDate(cellProps.row.original.date);
        },
      },
      {
        Header: "Rôle",
        accessor: "role",
        filterable: true,
      },
    ],
    []
  );

  const columnsInfo = [
    {
      Header: "Nom",
      accessor: "last_name",
    },
    {
      Header: "Prénoms",
      accessor: "first_name",
    },
    {
      Header: "Note",
      accessor: "note_driver",
    },
    {
      Header: "Téléphone",
      accessor: "telephone",
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "Type d'engin",
      accessor: "type_engin",
    },
    {
      Header: "Nombre de place",
      accessor: "nbr_place",
    },
    {
      Header: "Marque",
      accessor: "marque",
    },
    {
      Header: "Modele",
      accessor: "modele",
    },
    {
      Header: "Immatriculation",
      accessor: "immatriculation",
    },
  ];

  const columnStatistique = [
    {
      title: "Livraisons",
      prefix: "",
      suffix: "",
      value: livreurCoursesIn.length || 0,
    },
    {
      title: "Revenus",
      prefix: "XOF ",
      suffix: "",
      value: livreurCoursesRevenue || 0,
    },
    {
      title: "Filleuls",
      prefix: "",
      suffix: "",
      value: livreurParainage.parainee || 0,
    },
    {
      title: "Gains",
      prefix: "XOF ",
      suffix: "",
      value: livreurParainage.revenus || 0,
    },
  ];

  const documents = [
    {
      name: "Piece d'identite",
      path: "piece_identite",
      file: "piece_identite",
      exp: "date_expir_identite",
    },
    {
      name: "Attestation de residence",
      path: "attestation_residence",
      exp: null,
    },
    // {
    //   name: "Permis",
    //   path: "permis",
    //   exp: "date_expir_permis",
    // },
    {
      name: "Photo",
      path: "photo",
      exp: null,
    },
    {
      name: "Droit taxi",
      path: "droit_taxi",
      exp: "date_expir_droit_taxi",
    },
    {
      name: "Assurance",
      path: "assurance",
      exp: "date_expir_assurance",
    },
    {
      name: "Photo engin",
      path: "photo_engin",
      exp: null,
    },
    {
      name: "Carte grise",
      path: "carte_grise",
      exp: null,
    },
  ];

  document.title = props.t("Détails du livreur | Takci");

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Détails du livreur"
            pageTitle="Livreurs"
            pageTitleLink="/livreur"
          />
          {loading ? (
            <div className="text-center my-5">
              <Loader style={{ color: "#014c94" }} />
              <h2>Chargement...</h2>
            </div>
          ) : (
            <Row>
              <Col className="col-xxl-3">
                <Card className="h-100 w-100">
                  {selectlivreur.first_name && selectlivreur.last_name ? (
                    <>
                      <InfosPersonnelle
                        status={selectlivreur.statut}
                        avatar={
                          <div className="avatar-title bg-light text-dark rounded">
                            <i
                              className={`ri ri-e-bike-2-fill`}
                              style={{ fontSize: "50px" }}
                            />
                          </div>
                        }
                        head={
                          selectlivreur.first_name +
                          " " +
                          selectlivreur.last_name
                        }
                        since={selectlivreur.created_at}
                        columns={columnsInfo}
                        data={selectlivreur}
                      />

                      <DocumentsPersonnelle
                        onReload={() => setReload(!reload)}
                        user_id={selectlivreur.user_id}
                        accessor={documents}
                        data={selectlivreur}
                      />
                      {/* <DocumentsPersonnelle data={selectlivreur} /> */}
                    </>
                  ) : (
                    <Alert color="warning">
                      Aucune information disponible.
                    </Alert>
                  )}

                  {commentaires.length > 0 ? (
                    <React.Fragment>
                      <NoteCommentaire />
                      <CardBody className="p-4 border-top border-top-dashed">
                        <h6 className="text-muted text-uppercase fw-semibold mb-4">
                          Commentaires
                        </h6>
                        <CommentaireSlider commentaires={commentaires} />
                      </CardBody>
                    </React.Fragment>
                  ) : (
                    <CardBody className="p-4 border-top border-top-dashed">
                      <h6 className="text-muted text-uppercase fw-semibold mb-4">
                        Aucun commentaire disponible
                      </h6>
                    </CardBody>
                  )}
                </Card>
              </Col>

              <Col className="col-xxl-9">
                <Card className="w-100 h-100">
                  <StatistiquesDetail data={columnStatistique} />
                  {livreurCoursesIn.length > 0 ? (
                    <Card className="h-100 w-100">
                      <CardBody>
                        <div className="table-card gridjs-border-none pb-2">
                          <TableContainer
                            columns={columnsTable}
                            data={livreurCoursesIn || []}
                            isGlobalFilter={false}
                            isAddUserList={false}
                            customPageSize={10}
                            divClass="table-responsive"
                            tableClass="mb-0 table-borderless"
                            theadClass="table-light text-muted"
                          />
                        </div>
                      </CardBody>
                    </Card>
                  ) : (
                    <Alert color="warning">
                      Aucun historique de course disponible.
                    </Alert>
                  )}
                </Card>
              </Col>
            </Row>
          )}
          <ToastContainer closeButton={false} />
        </Container>
      </div>
    </React.Fragment>
  );
};

LivreurActivityHistory.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(LivreurActivityHistory));
